import type { AuthRepository } from '../../domain/ports/auth-repository';

export interface RequestEmailOtpInput {
  mfaToken: string;
}

export interface RequestEmailOtpResult {
  expiresInMinutes: number;
}

interface RequestEmailOtpUseCaseDeps {
  authRepository: AuthRepository;
}

export async function requestEmailOtpUseCase(
  input: RequestEmailOtpInput,
  deps: RequestEmailOtpUseCaseDeps,
): Promise<RequestEmailOtpResult> {
  const result = await deps.authRepository.requestMfaEmailOtp({ mfaToken: input.mfaToken });
  return { expiresInMinutes: result.expiresInMinutes };
}
